<template>
  <section class="itinerario-section">
    <div class="timeline-container">
      <h2 class="timeline-title">
        Itinerario <span class="sub">Agradecemos tu puntualidad. <br>¡No queremos empezar sin ti o que te pierdas el vals, llega a tiempo para compartir cada momento especial!</span>
      </h2>
      <div class="timeline">
        <div 
          v-for="evento in eventos" 
          :key="evento.nombre" 
          :ref="el => eventoRefs.push(el)" 
          class="timeline-item"
        >
          <div class="timeline-line" />
          <div class="timeline-icon-wrapper">
            <div class="timeline-star">
              ★
            </div>
            <img
              :src="evento.icono"
              :alt="evento.nombre"
              class="timeline-icon"
            >
          </div>
          <div class="timeline-time">
            <p>{{ evento.hora }}</p>
            <p
              v-if="evento.nota"
              class="nota"
            >
              {{ evento.nota }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { onMounted, ref } from 'vue';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'ItinerarioComponent',
  setup() {
    const eventos = [
      { nombre: 'Ceremonia Religiosa', hora: '7:00 PM', icono: require('@/assets/iglesia-itinerario1.gif') , nota:'Ceremonia' },
      { nombre: 'Recepción', hora: '9:00 PM', icono: require('@/assets/recepcion_time.png') , nota:'Recepción' },
      { nombre: 'Fiesta de la Fiesta', hora: '2:00 AM', icono: require('@/assets/fiesta_time.png'), nota: 'Fin de la Fiesta' },

    ];

    const eventoRefs = ref([]);

    onMounted(() => {
      eventoRefs.value.forEach((el) => {
        if (!el) return;

        const icon = el.querySelector('.timeline-icon');
        const star = el.querySelector('.timeline-star');
        const time = el.querySelector('.timeline-time');

        gsap.set([icon, star, time], { opacity: 0, y: 50 });

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                gsap.to(icon, {
                  opacity: 1,
                  y: 0,
                  delay: 0.1,
                  duration: 1,
                  ease: 'power2.out'
                });

                gsap.to(star, {
                  opacity: 1,
                  scale: 1,
                  delay: 0.3,
                  duration: 1,
                  ease: 'back.out(1.7)'
                });

                gsap.to(time, {
                  opacity: 1,
                  y: 0,
                  delay: 0.5,
                  duration: 1,
                  ease: 'power2.out'
                });

                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.3 }
        );

        observer.observe(el);
      });
    });

    return { eventos, eventoRefs };
  }
};
</script>

<style scoped>
.itinerario-section {
  padding: 40px 20px;
  background: linear-gradient(rgba(224, 133, 176, 0.84),rgba(224, 133, 176, 0.84)),
  url('@/assets/122.jpg');
  background-size: cover;
  
}

.timeline-container {
  max-width: 330px;
  margin: auto;
  position: relative;
}

.timeline-title {
  text-align: center;
  font-family: 'FeelingPassionate';
  font-size: 46px;
  margin-bottom: 40px;
  color: #434040;
}

.timeline-title .sub {
  display: block;
  font-size: 20px;
  font-family: serif;
  margin-top:8px;
  color: #434040;
}

.timeline {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 40px;
  border-left: 3px solid rgb(202, 202, 216);
}

.timeline-item {
  position: relative;
  padding-left: 30px;
  margin-bottom: 50px;
  display: flex;
  align-items: center;
}

.timeline-icon-wrapper {
  display: flex;
  align-items: center;
}

.timeline-line {
  position: absolute;
  top: 0;
  left: -1.5px;
  width: 3px;
  height: 100%;
  background-color: rgb(241, 241, 245);
  z-index: -1;
}

.timeline-star {
  color: #ffffff;
  font-size: 22px;
  margin-right: 10px;
  transform-origin: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  min-height: 30px;
}

.timeline-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.timeline-time {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 18px;
  color: #ffffff;
  text-align: left;
  margin-left: 20px;
}

.timeline-time .nota {
  font-size: 14px;
  color: #ffffff;
  margin-top: 4px;
  font-style: italic;
}
</style>
